// extracted by mini-css-extract-plugin
module.exports = {"profile":"styles_profile__3_qfD","profilePicture":"styles_profilePicture__1-wop","opaqueFilter":"styles_opaqueFilter__RMij4","backgroundPicture":"styles_backgroundPicture__UgXb4"};